import { AccordionDivider } from './styled';
export function SectionAccordionListDivider() {
    return <AccordionDivider />;
}
